import vue from 'vue';
import { default as Component } from 'vue-class-component';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

@Component({
  template: require('./extend-course.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
})
export class Extendcourse extends vue {
  days = '';
  // Preloader
  get loading() {
    return this.$store.state.loadingUser;
  }  
  get expiration() {
    return this.$store.state.user.expiration;
  }

  setDays(e) {
    this.days = e.target.value;
  }

  openCheckout() {
    this.$router.push({ name: 'checkout', params: { product: 'extend', days: this.days } });
  }
}
